// extracted by mini-css-extract-plugin
export default {"main":"dca-z"};